import { render, staticRenderFns } from "./RuleLinkModal.vue?vue&type=template&id=01c5966a&"
import script from "./RuleLinkModal.vue?vue&type=script&lang=js&"
export * from "./RuleLinkModal.vue?vue&type=script&lang=js&"
import style0 from "./RuleLinkModal.vue?vue&type=style&index=0&id=01c5966a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports